import { HttpClient } from '@angular/common/http';
import { Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AppVersionService } from '@shared/services/app-version.service';
import { AppModes, AppService } from '@shared/services/app.service';
import { BusyService } from '@shared/services/busy.service';
import { CountersService } from '@shared/services/counters.service';
import { LangService } from '@shared/services/lang.service';
import { ProducerService } from '@shared/services/producer.service';
import { RoutesService } from '@shared/services/routes.service';
import { ScreenService } from '@shared/services/screen.service';
import { UnsavedChangingsService } from '@shared/services/unsaved-changings.service';
import { Logger } from '@shared/utils/mix.utils';
import * as dayjs from 'dayjs';
import { RouteDataProps } from './app-routing.module';

@UntilDestroy()
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: [ './app.component.scss' ],
})
export class AppComponent implements OnInit {
  title = 'admin';
  showLoader: any;
  showSecondOutlet = false;
  hideSidebar = false;
  printMode = true;
  showAppUpdateSuggestion: { force: boolean } | null = null;

  constructor(
    private screenService: ScreenService,
    public appService: AppService,
    public unsavedChangingsService: UnsavedChangingsService,
    private langService: LangService,
    private producerService: ProducerService,
    private countersService: CountersService,
    public routesService: RoutesService,
    private router: Router,
    private route: ActivatedRoute,
    private titleService: Title,
    public busyService: BusyService,
    public appVersionService: AppVersionService,
    private http: HttpClient,
  ) {
    this.countersService.init();
    this.routesService.init();

    Logger.log('LANG:', langService.lang);
    dayjs.locale(this.langService.lang);

    this.routesService.showSecondOutlet$.pipe(untilDestroyed(this)).subscribe({
      next: (data) => {
        this.showSecondOutlet = data;
      }
    });

    this.appVersionService.showAppUpdateSuggestion$.pipe(untilDestroyed(this)).subscribe({
      next: (data) => {
        this.showAppUpdateSuggestion = data;
      }
    });
  }

  ngOnInit() {
    this.screenService.processWindowSize(window?.innerWidth, window?.innerHeight);

    this.appService.appMode$.pipe(untilDestroyed(this)).subscribe({
      next: (data) => {
        if (data === AppModes.PRODUCER) {
          this.producerService.loadProducer();
        }
      },
    });

    this.router.events.pipe(untilDestroyed(this)).subscribe({
      next: (event) => {
        if (event instanceof NavigationEnd) {
          const childRoute = this.route.children[0];
          if (childRoute?.snapshot?.data && childRoute.snapshot.data[RouteDataProps.hideSidebar]) {
            this.hideSidebar = true;
          } else {
            this.hideSidebar = false;
          }
        }
      },
    });

    this.setPageTitle();
  }

  @HostListener('window:resize')
  onResize() {
    this.screenService.processWindowSize(window?.innerWidth, window?.innerHeight);
  }

  setPageTitle() {
    this.titleService.setTitle($localize`Мелитта`);
  }

  testtmp() {
    let url = '/srv2';
    // url = 'http://api.melitta.technaxis.com:8000';
    this.http.get(url).subscribe({
      next: (data) => {
        console.log('API TEST SUCCESS');
      }
    });
  }
}
